/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const mostDifficult = useStore((state) => state.mostDifficult);
  const setMostDifficult = useStore((state) => state.setMostDifficult);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.mostDifficult.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={mostDifficult}
          onChange={(value: string) => {
            setMostDifficult(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'most-difficult',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Controlling cravings'}>
            <span>😫</span>
            {t('onboarding.mostDifficult.options.cravings')}
          </Option>
          <Option value={'Staying consistent'}>
            <span>📅</span>
            {t('onboarding.mostDifficult.options.stayingConsistent')}
          </Option>
          <Option value={'Finding time to cook'}>
            <span>🍳</span>
            {t('onboarding.mostDifficult.options.findingTime')}
          </Option>
          <Option value={'Not knowing what to eat'}>
            <span>🤷‍♀️</span>
            {t('onboarding.mostDifficult.options.whatToEat')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
